import React from 'react';
import moment from 'moment';
import { SortIcon } from '../components';
import { formatNumber } from 'utils/formatting';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import FileSaver from 'file-saver';
import _ from 'lodash';

const getSortingColumn = (title, isSort) => {
  return title;
};

export const TableHelper = {
  defaultColumn: (title, field, isSort, options) => {
    const returnedCol = {
      columnName: field,
      key: field,
      title: getSortingColumn(<pre>{title}</pre>, isSort),
      titleExcel: title.text ? title.text() : title,
      dataIndex: field,
      render: (value) => value,
      renderExcel: (value) => value,
      sorter: isSort,
    };
    return returnedCol;
  },
  priceColumn: (title, field, isSort) => {
    const returnedCol = {
      columnName: field,
      key: field,
      title: getSortingColumn(<pre>{title}</pre>, isSort),
      titleExcel: title,
      dataIndex: field,
      render: (value) => formatNumber(value, '0,0.00'),
      renderExcel: (value) => formatNumber(value, '0.00'),
      sorter: isSort,
    };
    return returnedCol;
  },
  dateColumn: (title, field, isSort) => {
    const returnedCol = {
      columnName: field,
      key: field,
      title: getSortingColumn(<pre>{title}</pre>, isSort),
      titleExcel: title,
      dataIndex: field,
      render: (value) => {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY');
      },
      renderExcel: (value) => {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY');
      },
      sorter: isSort,
    };
    return returnedCol;
  },
  datetimeColumn: (title, field, isSort) => {
    const returnedCol = {
      columnName: field,
      key: field,
      title: getSortingColumn(<pre>{title}</pre>, isSort),
      titleExcel: title,
      dataIndex: field,
      render: (value) => {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY HH:mm');
      },
      renderExcel: (value) => {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY HH:mm');
      },
      sorter: isSort,
    };
    return returnedCol;
  },
  integerColumn: (title, field, isSort) => {
    const returnedCol = {
      columnName: field,
      key: field,
      title: getSortingColumn(<pre>{title}</pre>, isSort),
      titleExcel: title,
      dataIndex: field,
      render: (value) => formatNumber(value, '0,0'),
      renderExcel: (value) => formatNumber(value, '0'),
      sorter: isSort,
    };
    return returnedCol;
  },
  percentColumn: (title, field, isSort) => {
    const returnedCol = {
      columnName: field,
      key: field,
      title: getSortingColumn(<pre>{title}</pre>, isSort),
      titleExcel: title,
      dataIndex: field,
      render: (value) => `${formatNumber(value, '0,0')}%`,
      renderExcel: (value) => `${formatNumber(value, '0')}%`,
      sorter: isSort,
    };
    return returnedCol;
  },
};

export const exportAsExcel = ({ columns, data, filename, sheetName }) => {
  return new Promise((resolve) => {
    const workbook = new Excel.Workbook();
    workbook.created = new Date();
    const sheet = workbook.addWorksheet(sheetName);
    const _columns = columns.reduce((results, col) => {
      if (!col.children) return results.concat([col]);
      return results.concat(col.children.map((child) => ({ ...child, title: `${col.title} - ${child.title}` })));
    }, []);
    sheet.columns = _columns.map(({ titleExcel, key, field, width }) => ({
      header: titleExcel,
      key,
      field,
      width: (width || 0) / 4 || 30,
    }));
    const row = sheet.getRow(1);
    row.font = {
      size: 16,
      bold: true,
    };
    row.alignment = { vertical: 'middle', horizontal: 'center' };
    row.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFF7F7F7' },
    };

    data.forEach((datum) => {
      const newRow = sheet.addRow(
        _columns.map(({ renderExcel, key }) => {
          if (_.isEmpty(key)) {
            return '';
          }
          const value = renderExcel(_.get(datum, key), datum);
          return _.isObject(value) ? _.get(value, 'props.children') : value;
        }),
      );
      newRow.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: isNaN(cell) ? 'left' : 'center' };
      });
    });
    workbook.xlsx.writeBuffer().then((buffer) => {
      FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename); // eslint-disable-line
      resolve();
    });
  });
};

export default TableHelper;
